import { Unique } from "../../../../shared/scripts/array-functions";
import { IFilter, InitializeFilterDropdown } from "../../../../shared/scripts/filtering";
import { getData } from "./site.utilities";

export class CTMSSiteActionItemsSection implements IFilter {

    items: any[];
    itemsTable: any;
    tableSelector = '#actionItemsTable';
    searchSelector = '#ai-search';
    clearSelector = '#ai-search-clear';

    url: string;
    showSiteColumn: boolean;

    constructor(handlerUrl: string, showSiteColumn = true){
        this.url = handlerUrl;
        this.showSiteColumn = showSiteColumn;

        this.initialize();
    }

    initialize() {
        this.itemsTable = $(this.tableSelector).DataTable({
            "dom": 'lrtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: false,
            scrollX: true,
            scrollY: '200px',
            scrollCollapse: true,
            order: [[0, 'asc']],
            orderCellsTop: true,
            columns: [
                { data:'DateDue', title: 'Due Date', className: '' },
                { data:'Type', title: 'Type', className: '' },
                { data:'Status', title: 'Status', className: '' },
                { data:'SiteName', title: 'Site', visible: this.showSiteColumn, className: '' },
                { data:'StudyName', title: 'Study', className: '' },
                { data: "IsUrgent", title: "Urgency", className: '', render: (data) => data ? "Urgent" : "" },
                { data: "IsCritical", title: "Critical", className: '', render: (data) => data ? "Critical" : "" },
                {
                    data: null,
                    title: "",
                    className: "ctms-table-col-actions",
                    orderable: false,
                    render: function (data, type, row) {
                        return `<button title="Edit"><i class="ctms-icon-pencil"></i></button>`;
                    }
                },
            ],
            rowCallback: (row: any, data: any) => {
                if (data.DateDue && data.Status !== 'Resolved') {
                    const d = new Date(data.DateDue);
                    const t = new Date();
                    if (d < t) row.classList.add('ctms-row-overdue') ;
                }
            }
        });

        InitializeFilterDropdown('#ai-type', [], this);
        InitializeFilterDropdown('#ai-study', [], this);

        $(this.searchSelector).on('input', (evt) => {
            $(this.tableSelector).DataTable().search(String($(evt.target).val() ?? '')).draw();
        });
        $(this.clearSelector).on('click', (evt) => {
            $(this.searchSelector).val('');
            $(this.tableSelector).DataTable().search('').draw();
        });
    }

    async loadData() {
        $('#actionItemSectionLoading').removeClass('d-none');

        this.items = await getData(this.url);

        this.itemsTable.clear();
        this.itemsTable.rows.add(this.items).draw();

        //update filters
        const typeValues: string[] = Unique(this.items.map(ai => ai.Type), true).sort();
        $('#ai-type').empty();
        $('#ai-type').append(typeValues.map(e => new Option(e, e, false, true)));
        $('#ai-type').selectpicker("refresh");

        const studyValues = Unique(this.items.map(ai => ai.StudyName), true).sort();
        $('#ai-study').empty();
        $('#ai-study').append(studyValues.map(e => new Option(e, e, false, true)));
        $('#ai-study').selectpicker("refresh");

        $('#actionItemSectionLoading').addClass('d-none');
    }


    // TODO clean up typings
    triggerFilter() {
        const type = $('#ai-type').val() as [any];
        const study = $('#ai-study').val() as [any];

        const filteredItems = this.items.filter((ai) => {
            return type.includes(ai.Type) && study.includes(ai.StudyName);
        });

        this.itemsTable.clear();
        this.itemsTable.rows.add(filteredItems).draw();
    }

    resetFilters() {
        $('#ai-type').selectpicker('selectAll');
        $('#ai-type').selectpicker('refresh');

        $('#ai-study').selectpicker('selectAll');
        $('#ai-study').selectpicker('refresh');

        this.itemsTable.clear();
        this.itemsTable.rows.add(this.items).draw();
    }

}